import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { isEmpty } from 'lodash';
import { filter } from 'rxjs/operators';
import { DialogService } from 'src/app/common/dialog/dialog.service';
import { PassengerCountRequest } from 'src/app/reports/service/bus-stop-report-file-preparator.service';
import { UserSettingsService } from 'src/app/settings/service/user-settings.service';
import { ExportRequest } from '../../model/export-request';
import { FileType, getChartFileTypes, getTabularFileTypes } from '../../model/file-type';
import { PassengersCountComponent } from '../passengers-count/passengers-count.component';

@Component({
  selector: 'app-export-view',
  templateUrl: './export-view.component.html',
  styleUrls: ['./export-view.component.scss']
})
export class ExportViewComponent implements OnInit {

  @Input()
  disabled: boolean = false;
  @Input()
  csv: boolean = false;
  @Input()
  pdf: boolean = false;
  @Input()
  xls: boolean = false;
  @Input()
  xlsx: boolean = false;
  @Input()
  chart: boolean = false;
  @Input()
  punctualityReport: boolean = false;
  @Input()
  playlistSummaryReport: boolean = false;
  @Input()
  passengerReport: boolean = false;

  @Output()
  exportSelected = new EventEmitter<ExportRequest>();
  @Output()
  generatePassengerCountRaport = new EventEmitter<PassengerCountRequest>();
  @Output()
  exportSummarySelected = new EventEmitter<ExportRequest>();

  reports: FileType[] = [];
  exportDataType = FileType;

  constructor(private matDialog: MatDialog, public settingsService: UserSettingsService, private diologService: DialogService) { }

  ngOnInit(): void {
    if (this.csv)
      this.reports.push(FileType.CSV);
    if (this.pdf)
      this.reports.push(FileType.PDF);
    if (this.xlsx)
      this.reports.push(FileType.XLSX);
    if (this.chart)
      this.reports.push(FileType.CHART);
  }

  isReportsAvailable(): boolean {
    return this.reports.find(v => getTabularFileTypes().indexOf(v) !== -1) != null;
  }

  isChartsAvailable(): boolean {
    return this.reports.find(v => getChartFileTypes().indexOf(v) !== -1) != null;
  }

  exportWithoutCron(fileType: FileType): void {
    this.exportSelected.emit(new ExportRequest(fileType, null, null));
  }

  openEditorForTables(): void {
    this.openEditorForm('exportData', false, this.reports.filter(report => report !== FileType.CHART));
  }

  openEditorForSummaryTables(): void {
    const dialog = this.diologService.openDataExportDialog('exportSummaryData', false, this.reports.filter(report => report !== FileType.CHART));
    dialog.afterClosed().subscribe((data: ExportRequest) => {
      if (!isEmpty(data) && !data.isEmpty()) {
        this.exportSummarySelected.emit(data);
      }
    });
  }

  openEditorForChart(): void {
    this.openEditorForm('createChart', false, [FileType.CHART]);
  }

  openEditorForm(title: string, isSchedule: boolean, reports: FileType[]): void {
    const dialog = this.diologService.openDataExportDialog(title, isSchedule, reports);
    dialog.afterClosed().subscribe((data: ExportRequest) => {
      if (!isEmpty(data) && !data.isEmpty()) {
        this.exportSelected.emit(data);
      }
    });
  }

  openPassengerReportDialog(): void {
    this.matDialog.open(PassengersCountComponent)
      .afterClosed().pipe(filter(data => data)).subscribe((request: PassengerCountRequest) => this.generatePassengerCountRaport.emit(request));
  }

}
